<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="$t('Shelf')"
      :active.sync="isSidebarActiveLocal"
      @close="closeShelfPopup"
      @cancel="closeShelfPopup"
      fullscreen
    >
      <b-row style="margin-top: 25px">
        <b-col lg="5">
          <vs-card>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="$t('CompanyName')"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="CompanyName"
                  type="text"
                  name="shelfName"
                  disabled
                  class="w-full"
                />
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="$t('CorridorName')"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="CorridorName"
                  type="text"
                  name="shelfName"
                  disabled
                  class="w-full"
                />
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="$t('ShelfName')"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="shelfName"
                  type="text"
                  name="shelfName"
                  v-validate="'required'"
                  class="w-full"
                />
                <span class="text-danger text-sm" v-show="errors.has('shelfName')">{{
                  errors.first("shelfName")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="$t('ShelfCode')"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="shelfCode"
                  type="text"
                  name="shelfCode"
                  v-validate="'required'"
                  class="w-full"
                />
                <span class="text-danger text-sm" v-show="errors.has('shelfCode')">{{
                  errors.first("shelfCode")
                }}</span>
              </b-col>
            </b-row>
						<div class="items-center pl-6 mt-5 mb-0">
							<b-row align-h="end">
								<b-col cols="3" md="auto" style="padding: 0px">
									<b-button
										class="bg-danger"
										style="border-color: white"
										v-on:click="closeShelfPopup"
									>
										<Icon
											icon="material-symbols:cancel-outline"
											style="margin-right: 5px"
											width="20"
											height="20"
										/>{{ $t("Cancel") }}
									</b-button>
								</b-col>
								<b-col cols="3" md="auto">
									<b-button
										class="bg-primary"
										style="border-color: white"
										v-on:click="submitData()"
									>
										<Icon
											icon="material-symbols:save-outline"
											style="margin-right: 5px"
											width="20"
											height="20"
										/>{{ $t("Save") }}
									</b-button>
								</b-col>
							</b-row>
						</div>
          </vs-card>
          
        </b-col>
        <b-col>
          <vs-card>
            <ag-grid-vue
              style="width: 100%; height: 400px"
              class="ag-theme-alpine"
              :suppressRowClickSelection="true"
              :defaultColDef="defaultColDef"
              :columnDefs="shelfColumns"
              :rowData="shelf"
              :localeText="localeText"
              @grid-ready="onGridReady"
            >
            </ag-grid-vue>
          </vs-card>
        </b-col>
      </b-row>
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import { Validator } from "vee-validate";
import updateDeleBtnDynamic from "../CellRenderers/updateDeleteBtnDynamic.vue";
export default {
  components: { Icon, vSelect, AgGridVue, updateDeleBtnDynamic },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
    shelfDetailData: {
      default: () => {},
    },
  },
  data() {
    return {
      ROLE: this.$store.state.AppActiveUser.ROLE,
      shelfCode: "",
      shelfName: "",
      shelfId: "",
      CompanyName: "",
      CorridorName: "",
      CorridorId: "",
      shelf: [],
      shelfColumns: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
    };
  },
  methods: {
		parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },
    getShelf() {
      const vs = this.$vs;

      this.shelf = [];
      this.shelfColumns = [];
      this.$store
        .dispatch("storehouse/listShelfForCorridor", this.data.CorridorId)
        .then((response) => {
          if (response.success == true) {
            this.shelf = JSON.parse(response.json);
            if (this.shelf.length > 0) {
              let columnList = Object.keys(this.shelf[0]);
              this.shelfColumns.push({
                width: 100,
                pinned: "left",
                cellRendererFramework: "updateDeleBtnDynamic",
                cellRendererParams: {
                  editMethod: "addShelfBtn",
                  deleteMethod: "deleteShelf",
                },
              });
              columnList.forEach((val, index) => {
                if (val.toString().includes("Date") == true) {
                  this.shelfColumns.push({
                    cellRendererFramework: "TextViewCellRenderer",
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                    valueFormatter: (params) => this.parseDate(params.data[val]),
                  });
                } else if (val.toString().includes("Id") == true) {
                } else
                  this.shelfColumns.push({
                    cellRendererFramework: "TextViewCellRenderer",
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                  });
              });
            }
          } else console.log(response.statusText);
          /*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
        });
    },
    deleteShelf(data) {
      const vs = this.$vs;
      this.$store
        .dispatch("storehouse/deleteShelf", data.ShelfId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.getShelf();
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    submitData() {
      var createdId = uuid.v4();
      const vs = this.$vs;
      let method = "addShelf";
      this.$validator.validateAll().then((result) => {
        if (result) {
          let obj = {
            shelfId: createdId,
            shelfName: this.shelfName,
            shelfCode: this.shelfCode,
            corigorId: this.data.CorridorId,
          };
          if (this.shelfId) {
            method = "updateShelf";
            obj = {
              shelfId: this.shelfId,
              shelfName: this.shelfName,
              shelfCode: this.shelfCode,
              corigorId: this.CorridorId,
            };
          } 
          this.$store
            .dispatch("storehouse/" + method, obj)
            .then((response) => {
              if (response.status == 200) {
                vs.notify({
                  text: response.data.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                this.shelfId = "";
                this.shelfName = "";
                this.shelfCode = "";
                this.getShelf();
              } else {
                vs.notify({
                  text: response.data.message.toString(),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            })
            .catch((error) => {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            });
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
    closeShelfPopup() {
      this.shelfCode = "";
      this.shelfName = "";
      this.shelfId = "";
      this.CorridorId = "";
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
  },
  mounted() {
    this.$root.$on("addShelfBtn", (data) => {
      this.shelfId = data.ShelfId;
      this.shelfCode = data.ShelfCode;
      this.shelfName = data.ShelfName;
    });
    this.$root.$on("deleteShelf", (data) => {
      this.deleteShelf(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("addShelfBtn");
    this.$root.$off("deleteShelf");
  },
  watch: {
    shelfDetailData(val) {
      return val;
    },
    data(val) {
      return val;
    },
    isSidebarActive(val) {
      if (val == true) {
        this.getShelf();
        this.CompanyName = this.data.CompanyName;
        this.CorridorName = this.data.CorridorName;
        const dict = {
          custom: {
            shelfName: {
              required: this.$t("shelfNameRequired"),
              alpha: this.$t("shelfNameRequired"),
            },
            shelfCode: {
              required: this.$t("shelfCodeRequired"),
              alpha: this.$t("shelfCodeRequired"),
            },
          },
        };
        Validator.localize("en", dict);
        if (this.data != "") {
          //  this.shelfCode = this.data.ShelfCode;
          //  this.shelfName = this.data.ShelfName;
          this.CorridorId = this.data.CorridorId;
        }
        if (this.shelfDetailData != "") {
          this.shelfCode = this.shelfDetailData.ShelfCode;
          this.shelfName = this.shelfDetailData.ShelfName;
          this.shelfId = this.shelfDetailData.ShelfId;
          this.CompanyName = this.shelfDetailData.CompanyName;
          this.CorridorName = this.shelfDetailData.CorridorCode;
          this.CorridorId = this.shelfDetailData.CorrigorId;
        }
      }
      return val;
    },
  },
  computed: {
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
};
</script>
